import React, {useCallback, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
  SetSliderValueMinMax,
  SetSliderValue,
  SetIsSearching,
  SetUrlPrefix,
  SetImgPrefix,
  SetAsyncData,
  SetListingBanner,
  SetIsExpanded,
  SetShowOverlay,
  SetActiveFilters,
  SetPrevProducts,
  SetProducts,
  SetResultsCount,
  SetFilters,
  SetMasterCategories,
  SetPages,
  SetPage,
  SetSuggestedWords
} from "../../state/actions/index";
import './ActiveFiltersContainer.css';
import ActiveFilter from "../ActiveFilter/ActiveFilter";
import SortDropdown from "../SortDropdown/SortDropdown";
import ActiveFiltersOverlay from "../ActiveFiltersOverlay/ActiveFiltersOverlay";
import Utils from '../../utils/Utils';
import axios from 'axios';


const ActiveFiltersContainer = () => {

  const activeFilters = useSelector(state => state.activeFilters);
  const searchWord = useSelector(state => state.searchWord);
  const config = useSelector(state => state.config);
  const isSearching = useSelector(state => state.isSearching);
  const isAutocompleteOpen = useSelector(state => state.isAutocompleteOpen);
  const sort = useSelector(state => state.sort);
  const queryOptions = useSelector(state => state.config.queryOptions);
  const card = useSelector(state => state.config.card);
  const sliderValue = useSelector(state => state.sliderValue);
  const isMobile = useSelector(state => state.isMobile);
  const sliderValueMinMax = useSelector(state => state.sliderValueMinMax);
  const activeSort = useSelector(state => state.config.triggers.sort);
  const autocomplete = useSelector(state => state.config.autocomplete);
  const clearFilters = useSelector(state => state.config.placeholders.clearFilters);
  const activeFiltersPlaceholder = useSelector(state => state.config.placeholders.activeFilters);
  const display = useSelector(state => state.config.display);
  const configFilters = useSelector(state => state.config.filters);
  const accentColor = useSelector(state => state.config.accentColor);
  const showOverlay = useSelector(state => state.showOverlay);
  const products = useSelector(state => state.products);
  const defaultMasterCategories = useSelector(state => state.defaultMasterCategories);
  const dispatch = useDispatch();

  const categoryKey = useMemo(() => {
    var valueToReturn = "";
    Object.keys(configFilters).forEach(filter => {
      if (configFilters[filter].isCategory) valueToReturn = filter
    })
    return valueToReturn;
  }, [configFilters])

  var iconStyle = useMemo(() => {
    return {backgroundColor: accentColor}
  }, [accentColor]);
  var rows = useMemo(() => isMobile ? queryOptions.rows.mobile : queryOptions.rows.desktop, [isMobile, queryOptions])

  const removeAllFilters = useCallback(() => {
      dispatch(SetIsSearching(true));
      dispatch(SetAsyncData([]));
      var priceGroup = {}
      priceGroup.id = window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType ? window.AS_ADVANCED_CONFIG.visitorType : config.priceGroup.id;
      priceGroup.currency = window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode ? window.AS_ADVANCED_CONFIG.currencyCode : config.priceGroup.currency;
      var localSearchUrl = Utils.getSearchUrl(config.baseUrl, config.queryOptions, priceGroup, config.shopId, config.jsonFast);
      axios.get(Utils.insertWordInSearchUrl(localSearchUrl, searchWord, [], sort, 1, configFilters, rows))
        .then(res => {
          var response = res.data;
          dispatch(SetIsExpanded({}));
          dispatch(SetActiveFilters([]));
          dispatch(SetPrevProducts(products));
          dispatch(SetProducts(Utils.refactorUrl(response.data, response.header.imagePrefix, response.header.urlPrefix, card.img, card.url)));
          dispatch(SetSuggestedWords(response.suggestions));
          dispatch(SetResultsCount(response.header.results_count));
          dispatch(SetSliderValue(Utils.addSliderValue(response, sliderValue)));
          dispatch(SetSliderValueMinMax(Utils.addSliderValue(response, sliderValueMinMax)));
          dispatch(SetFilters(response));
          dispatch(SetPages(parseInt((response.header.results_count - 1) / rows) + 1));
          dispatch(SetPage(1));
          dispatch(SetListingBanner(response.banners[0]));
          dispatch(SetMasterCategories(response.stats[categoryKey] ? Utils.refactorMasterCategories(Object.keys(response.stats[categoryKey])) : defaultMasterCategories));
          dispatch(SetUrlPrefix(response.header.urlPrefix));
          dispatch(SetImgPrefix(response.header.imagePrefix));
          if (config.webhook.key !== '') Utils.getAsyncData(config.webhook, response.data, priceGroup).then(value => dispatch(SetAsyncData(value.asyncData)));
          var websiteSearchBar = document.getElementById('accelasearch-bar-container-container');
          const event = new CustomEvent('as-search-event', {detail: {searchWord: searchWord, filters: [], page: 1}});
          websiteSearchBar.dispatchEvent(event)
        })
        .finally(() => dispatch(SetIsSearching(false)))
    },
    [dispatch, searchWord, defaultMasterCategories, sort, sliderValue, rows, sliderValueMinMax, config, configFilters, products, categoryKey, card]);

  var minChars = useMemo(() => isMobile ? autocomplete.minChars.mobile : autocomplete.minChars.desktop, [isMobile, autocomplete])
  var isSearchwordShort = useMemo(() => searchWord.length < minChars, [searchWord, minChars])

  return <div className="active-filters-container">
    {!isMobile && products.length > 0 ? ((display === "half-screen" && activeFilters.length > 2) || (display === "full-screen" && activeFilters.length > 3) || (display === "windowed" && activeFilters.length > 0) ?

      (showOverlay ?
        <ActiveFiltersOverlay />
        : <div className="compact-filters">
          <div className="filters-button" onClick={() => dispatch(SetShowOverlay(true))}>
            <span style={iconStyle} className="icon"></span>
            <span className="value">{activeFilters.length} {activeFiltersPlaceholder}</span>
          </div>
          <div className="rimuovi-filters" onClick={removeAllFilters}> {clearFilters} </div>
        </div>)
      : activeFilters.map((el, index) => (
        <ActiveFilter value={el} key={'active_filter_' + index} defaultActiveKey={'active_filter_' + index}/>
      ))) : null}

    {activeSort && !(products.length === 0 && !isSearching && !isAutocompleteOpen && (activeFilters.length > 0 || !isSearchwordShort)) ?
      <SortDropdown/> : null}
  </div>
};

export default ActiveFiltersContainer;
